import { useEffect, useState } from 'react';

function isVolumeControlSupported(): Promise<boolean> {
    return new Promise((resolve) => {
        const obj = document.createElement('video');

        try {
            obj.volume = 0.123;
            setTimeout(() => {
                resolve(obj.volume == 0.123);
            }, 100);
        } catch (e) {
            resolve(false);
        }
        obj.remove();
    });
}

/**
 * On iOS devices, the audio level is always under the user’s physical control.
 * The volume property is not settable in JavaScript.
 * Reading the volume property always returns 1.
 *
 */

const useVolumeSupported = (): boolean => {
    const [isSupported, setIsSupported] = useState(false);
    useEffect(() => {
        isVolumeControlSupported().then((supported) => {
            setIsSupported(supported);
        });
    }, []);
    return isSupported;
};

export { isVolumeControlSupported };

export default useVolumeSupported;
